<template>
  <div
    class="arrow-icon-white"
    :class="{
      [direction + '-arrow-icon-white']: true
    }"
  >
    <i-arrow
      :class="{
        [color + '-color']: true
      }"
      :title="null"></i-arrow>
  </div>
</template>

<script>
import IArrow from 'vue-material-design-icons/ChevronDown.vue'

export default {
  components: { IArrow },
  props: {
    color: {
      type: String,
      default: 'white'
    },
    title: String,
    direction: {
      validator: function (value) {
        return [ 'up', 'right', 'down', 'left' ].indexOf(value) !== -1
      }
    }
  }
}
</script>

<style scoped>
.arrow-icon-white { align-items: center; display: flex; font-size: 24px; height: 40px; justify-content: center; width: 40px; }
.arrow-icon-white > span { -webkit-transition: all 0.3s; -moz-transition: all 0.3s; -o-transition: all 0.3s; transition: all 0.3s; color: white !important; }
.up-arrow-icon-white > span { -webkit-transform: rotate(-180deg); -moz-transform: rotate(-180deg); -o-transform: rotate(-180deg); transform: rotate(-180deg); }
.right-arrow-icon-white > span { -webkit-transform: rotate(-90deg); -moz-transform: rotate(-90deg); -o-transform: rotate(-90deg); transform: rotate(-90deg); }
.left-arrow-icon-white > span { -webkit-transform: rotate(-270deg); -moz-transform: rotate(-270deg); -o-transform: rotate(-270deg); transform: rotate(-270deg); }
</style>



// WEBPACK FOOTER //
// src/components/icons/ArrowIconWhite.vue